export const VideoUrls = {
  vimeo: (videoUrl: string): string => `https://vimeo.com/api/oembed.json?url=${videoUrl}`,
  youtube: (videoUrl: string): string => (
    `https://www.youtube.com/oembed?url=${videoUrl}&format=json`
  ),
  vimeoIframe: (id: string) => `https://player.vimeo.com/video/${id}`,
  youtubeIframe: (id: string) => `https://www.youtube.com/embed/${id}`,
};
